import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import CurrencyContext from "./contexts/currency";
import ThemeContext from "./contexts/theme";
import { HelmetProvider } from "react-helmet-async";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <CurrencyContext>
        <ThemeContext>
          <App />
        </ThemeContext>
      </CurrencyContext>
    </HelmetProvider>
  </React.StrictMode>,
);

reportWebVitals();